module.exports = __webpack_public_path__ + "media/images/pc/costumes/mv_shiromuku-3e7dcd42a0624a0e1ac043d23f252e9a.jpg";